<template>
<!-- 审核版本 -->
  <el-dialog
    :title="'APP'+$t('menu.versionReview')"
    :visible.sync="dialogVisible"
    width="650px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <div class="app-text">
        <div class="app-li">
          <label for="">{{$t('pages.system.text14')}}</label>
          <span>{{ lookUpData.version }}</span>
        </div>
        <div class="app-li">
          <label for="">{{$t('pages.system.text15')}}</label>
          <div>{{ lookUpData.intro }}</div>
        </div>
        <div class="app-li">
          <label for="">{{$t('pages.system.text16')}}</label>
          <span
            ><a :href="lookUpData.filePath" :download="lookUpData.fileName">{{
              lookUpData.fileName
            }}</a>
            <i>{{ sizeReset(lookUpData.fileSize) }}</i></span
          >
        </div>
      </div>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="auto"
        class="demo-ruleForm"
        :rules="rules"
      >
        <el-form-item :label="$t('pages.system.text25')" prop="status">
          <el-radio-group v-model="ruleForm.status">
            <el-radio :label="1">{{$t('pages.system.text23')}}</el-radio>
            <el-radio :label="2">{{$t('pages.system.text24')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text26')" prop="annotation">
          <el-input
            v-model="ruleForm.annotation"
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{$t('button.cancel')}}</el-button>
      <el-button type="primary" @click="submit">{{$t('button.determine')}}</el-button>
    </span>
  </el-dialog>
</template>


<script>
import { validatDescribe } from "../../../../utils/util/test";
import { sizeReset } from "../../../../utils/util/validate";
export default {
  data() {
    return {
      ruleForm: {
        annotation: "", //审核批注
        id: "", // id
        reviewerId: "", //审核人id
        status: null, // 状态,0代表未审核，1代表审核通过，2代表审核失败
      },
      rules: {
        status: [
          {
            required: true,
            message: this.$t('pages.system.text27'),
            trigger: "blur",
          },
        ],
        annotation: [
          { validator: validatDescribe, trigger: "blur" },
          {
            required: true,
            message: this.$t('pages.system.text28'),
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        this.ruleForm = {
          annotation: "", //审核批注
          id: this.lookUpData.id, // id
          reviewerId: JSON.parse(localStorage.getItem("userInfo")).id, //审核人id
          status: null, // 状态,0代表未审核，1代表审核通过，2代表审核失败
        };
        console.log(this.lookUpData);
      }
    },
  },
  props: ["dialogVisible", "lookUpData"],
  methods: {
    sizeReset(size) {
      return sizeReset(size);
    },
    //取消
    handleClose() {
      this.$emit("dialogClose");
    },
    //确定
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.request.versionReviewReview(this.ruleForm).then(()=>{
            this.$emit('versionReviewReviewList')
            this.$message.success(this.$t('pages.system.text29'));
            this.handleClose();
          })
        }
      });
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
}
.app-text {
  display: flex;
  flex-direction: column;
}
.app-li {
  display: flex;
  margin-bottom: 16px;
}
.app-li label {
  margin-right: 20px;
  display: block;
  width: 90px;
  text-align: end;
}
.app-li span {
  display: flex;
  align-items: center;
}
.app-li span a {
  margin-right: 20px;
}
.app-li div {
  display: flex;
  flex-direction: column;
}
</style>